import { render, staticRenderFns } from "./TextToggle.vue?vue&type=template&id=8d613524"
import script from "./TextToggle.vue?vue&type=script&lang=js"
export * from "./TextToggle.vue?vue&type=script&lang=js"
import style0 from "./TextToggle.vue?vue&type=style&index=0&id=8d613524&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports